<template>
	<!-- 副导航栏 -->
	<div class="little-nav flex" :style="{color: fontColor}">
		<div class="left-nav">
			<div class="scroll" ref="scroll">
				<template v-for="(item, index) in navlist">
                    <div v-if="goWay=='name'" :key="index" @click="clickItem(index, item.link)" 
                         ref="navItem" @mouseenter="enter(index)"
                         :class="[copyright=='forum'? ['forum-nav-item', current == item.link ? 'forum-active': ''] :['science-nav-item',current == index ? 'science-active': '' ]]"
                    >
                        {{ item.text }}
                        <b-icon class="arrow" v-if="item.sub"  icon="chevron-down"></b-icon>
                        <ul  v-if="item.sub "  
                            class="nav-dropdown"
                            :style="{'left': leftDistance+'px'}">
                                <li class="dropItem" 
                                v-for="(subItem, ind) in item.sub"   @click.stop="clickSubItem(subItem.link)"
                                :key="ind"
                                >{{subItem.text}}</li>
                        </ul>
                    </div>
                    <div v-if="goWay=='index'" :key="index" @click="clickItem(index, item.link, item.SecId)" 
                         ref="navItem" @mouseenter="enter(index)"
                         >
                            <span :class="[copyright=='forum'? ['forum-nav-item', current == index ? 'forum-active': ''] :['science-nav-item',current == index ? 'science-active': '' ]]">{{ item.text }}</span>
                            <b-icon class="arrow" v-if="item.sub"  icon="chevron-down"></b-icon>
                            <ul  v-if="item.sub "  
                                class="nav-dropdown"
                                :style="{'left': leftDistance+'px'}">
                                    <li class="dropItem" 
                                    v-for="(subItem, ind) in item.sub"   @click.stop="clickSubItem(subItem.link)"
                                    :key="ind"
                                    >{{subItem.text}}</li>
                            </ul>
                    </div>
				</template>
			</div>
		</div>
        <div class="right-nav">
            <!-- 左侧插槽 -->
            <slot name="right-nav"></slot>
        </div>
	</div>
</template>
<script>
export default {
    props:{
        fontColor:{
            type: String,
            default: '#999999'
        },
        goWay:{
            type: String, // 默认为'index' 通过index控制 ||  值'name'：表示通过路由的name来高亮导航
            default: 'index'
        },
        current: {
            type:[String, Number],
        },
        navlist: Array,
        year: {
            type: Object,
            default: ()=>{}
        },
        copyright:{  //默认主题science || 论坛主题设置copyright='forum'
            type: String,
            default:()=>'science'
        }
    },
    data(){
        return{
            leftDistance: 0,
            show: false,
        }
    },
    model:{
        prop: 'current',
        event: 'currentChange'
    },
    watch:{
        current:{
            handler(val){
                this.$emit('currentChange', val)
            },
            immediate: true,
            deep: true
        },
        goWay(val){
            // console.log(val)
        }
    },
    
    methods:{
		clickItem(index, path, SecId) {
            this.$emit('changeCurrent',index, path, SecId)
        },
        enter(index){
            this.leftDistance = this.$refs.navItem[index].getBoundingClientRect().left - this.$refs.scroll.getBoundingClientRect().left	// this.current = index
        },
        clickSubItem(index, path){
            this.$emit('subClick', index, path)
        }
    }
}
</script>
<style lang="scss" scoped>
.little-nav {
    position: relative;
	display: flex;
	justify-content: space-between;
	height: 4.1rem;
	line-height: 4rem;
	border-bottom: 0.1rem solid #eee;
   margin: 2rem 1rem 0rem 0rem!important;
	.left-nav {
		flex: 3;
		overflow: hidden;
        height: 6rem;
		.scroll {
			display: flex;
			overflow-x: auto;
			overflow-y: hidden;
			white-space: nowrap;
            height: 5rem;
			.science-nav-item,
             .forum-nav-item {
				margin: 0 2rem;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                .arrow{
                position: relative;
                width: 100%;
                top: -20px;
                }
			}
            .science-active{
                color: #c8a063;
				border-bottom: 0.1rem solid #c8a063;
            }
            .forum-active{
                color: $forum-theme-blue;
				border-bottom: 0.1rem solid $forum-theme-blue;
            }
            .science-nav-item :hover,
            .science-nav-item :focus{
                color: #c8a063;
				border-bottom: 0.1rem solid #c8a063;
                .nav-dropdown{
                     display: block;
                 }
            }
			
            .forum-nav-item:hover,
            .forum-nav-item:focus{
                color: $forum-theme-blue;
				border-bottom: 0.1rem solid $forum-theme-blue;
                 .nav-dropdown{
                     display: block;
                 }
            }
             .nav-dropdown{
                position: absolute;
                display: none;
                color:#666666;
                top: 4rem;
                line-height: 2.2rem;
                min-width: 8rem;
                background: #f2f2f2;
                text-align: center;
                z-index: 99;
                .dropItem:hover{
                color: $forum-theme-blue;

                }
            }
            .show{
                display: block;

            }
		}
	}
}
</style>
